import { hot } from 'react-hot-loader/root';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';
import { hotjar } from 'react-hotjar';

import store from '#redux/store';
import { useMount } from '#hooks/useMount';
import { SCOPE } from '#constants/auth0';
import MixpanelService from '#services/MixpanelService';
import { configureSentry } from '#config/sentry';

import Routes from './components/general/Routes';

const App = () => {
  useMount(() => {
    hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_SV);
    MixpanelService.init();
    configureSentry();
  });
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      redirectUri={window.location.origin}
      audience={process.env.REACT_APP_JWKS_AUDIENCE}
      scope={SCOPE}>
      <Provider store={store}>
        <Routes />
      </Provider>
    </Auth0Provider>
  );
};

export default hot(App);
